import moment from 'moment';
import { pipe } from 'ramda';
import { ofNullable, map, orElse, flatMap, filter, Just, mapTo } from 'core/maybe';
import { error, ok, flatMap as flatMapR } from 'core/result';
const parseSingle = pipe((x)=>x !== null && x !== void 0 ? x : null, ofNullable, map((x)=>x.replace(/,/g, '')), map((x)=>parseInt(x, 10)), filter((x)=>!Number.isNaN(x)), orElse(0));
const parseHours = pipe((x)=>x !== null && x !== void 0 ? x : null, ofNullable, map((x)=>x.replace(/,/g, '')), map((x)=>parseFloat(x)), filter((x)=>!Number.isNaN(x)), orElse(0));
const aggregate_parser = (regexes)=>(value)=>pipe(()=>{
            var _regexes_find;
            return ofNullable((_regexes_find = regexes.find((x)=>x.test(value !== null && value !== void 0 ? value : ''))) !== null && _regexes_find !== void 0 ? _regexes_find : null);
        }, map((x)=>{
            var _value_match;
            return (_value_match = value.match(x)) !== null && _value_match !== void 0 ? _value_match : null;
        }), flatMap(ofNullable), map((x)=>{
            var _x_groups;
            return (_x_groups = x.groups) !== null && _x_groups !== void 0 ? _x_groups : null;
        }), flatMap(ofNullable), map((x)=>{
            var _x_hours, _x_minutes;
            return {
                hours: (_x_hours = x.hours) !== null && _x_hours !== void 0 ? _x_hours : '0',
                minutes: (_x_minutes = x.minutes) !== null && _x_minutes !== void 0 ? _x_minutes : '0'
            };
        }))();
const regexes = [
    /^(?<hours>-?[\d,]+)h\s?(?<minutes>\d+)m$/,
    /^(?<hours>-?[\d,]+)?:(?<minutes>\d+)$/,
    /^(?<hours>-?(\d[\d,]*(\.\d+)?)|(-?\.\d+))h?$/,
    /^(?<minutes>-?\d+)m$/
];
export const durationParser = pipe(aggregate_parser(regexes), map(({ hours, minutes })=>[
        hours,
        minutes
    ]), map(([h, m])=>[
        parseHours(h),
        parseSingle(m)
    ]), map(([h, m])=>moment.duration(h, 'hours').add(moment.duration(m, 'minutes'))), map((d)=>d.asMinutes()), map(Math.floor), map(ok), orElse(error('invalid_pattern')));
export const nonEmpty = (p)=>(value)=>value === '' ? error('empty') : p(value);
export const withDefaultValue = (empty)=>(p)=>(value)=>value === '' ? ok(empty) : p(value);
const withParsedValueError = (hasError)=>(p)=>pipe(p, flatMapR((x)=>pipe(()=>hasError(x), map((e)=>error(e)), orElse(ok(x)))()));
export const withPredicatedParseError = (e, predicate)=>withParsedValueError(pipe(Just, filter(predicate), mapTo(e)));
export const withMaximum = (maximum)=>withPredicatedParseError('exceeds_maximum', (x)=>x > maximum);
export const withMinimum = (minimum)=>withPredicatedParseError('less_than_minimum', (x)=>x < minimum);
export const withZeroAsError = withPredicatedParseError('zero', (x)=>x === 0);
const withLessThanOneDay = withPredicatedParseError('greater_than_one_day', (x)=>x > moment.duration(1, 'day').asMinutes());
export const withGreaterThanZero = withPredicatedParseError('less_than_zero', (x)=>x < 0);
// keeping this for test. We can remove this once we modified the parser.test.ts
export const parser = pipe(()=>durationParser, withGreaterThanZero, withZeroAsError, withLessThanOneDay, nonEmpty)();
